import { Outlet } from "react-router-dom";
import { TopNavBar } from "../TopNavBar";
import ManageStaffModal from "../../features/Staff/components/ManageStaffModal";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ChatHeaderProvider } from "../../contexts/ChatHeaderContext";
import useAccountShopStatusSubscription from "../../features/Shop/hooks/useAccountShopStatusSubscription";
import {
  fetchChatbotEventAccess,
  resetChatbotEventAccess,
} from "../../features/Chatbot/chatbotEventAccessSlice";

const Layout = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [isOpenManageStaffModal, setIsOpenManageStaffModal] = useState(false);

  useAccountShopStatusSubscription({
    accountId: auth.user?.accountId,
    staffId: auth.user?._id,
    enabled:
      auth.isAuthenticated &&
      auth.user?.accountId != null &&
      Boolean(auth.user?._id),
  });

  useEffect(() => {
    if (!auth.isAuthenticated || !auth.user?.accountId) {
      dispatch(resetChatbotEventAccess());
      return;
    }

    dispatch(fetchChatbotEventAccess(auth.user.accountId));
  }, [dispatch, auth.isAuthenticated, auth.user?.accountId]);

  const canManageStaff =
    auth.user?.role?.includes("super_admin") ||
    auth.user?.role?.includes("admin");

  const handleManageStaffClick = () => {
    if (canManageStaff) {
      setIsOpenManageStaffModal(true);
    }
  };

  const [isOpenManageTagModal, setIsOpenManageTagModal] = useState(false);

  const handleManageTagClick = () => {
    setIsOpenManageTagModal(true);
  };

  const [isOpenManageQuickMessageModal, setIsOpenManageQuickMessageModal] =
    useState(false);

  const handleManageQuickMessageClick = () => {
    setIsOpenManageQuickMessageModal(true);
  };

  const [staffs, setStaffs] = useState([]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <ChatHeaderProvider>
      <div className="h-screen flex flex-col bg-white text-gray-800 font-sans">
        <TopNavBar onToggleSidebar={() => setIsSidebarOpen((prev) => !prev)} />
        <Outlet
          context={[
            isOpenManageTagModal,
            setIsOpenManageTagModal,
            isOpenManageQuickMessageModal,
            setIsOpenManageQuickMessageModal,
            handleManageStaffClick,
            handleManageTagClick,
            handleManageQuickMessageClick,
            staffs,
            setStaffs,
            isSidebarOpen,
            setIsSidebarOpen,
          ]}
        />
        {canManageStaff && (
          <ManageStaffModal
            isOpen={isOpenManageStaffModal}
            setIsOpen={setIsOpenManageStaffModal}
            staffs={staffs}
            setStaffs={setStaffs}
          />
        )}
      </div>
    </ChatHeaderProvider>
  );
};

export default Layout;
